module.exports = __webpack_public_path__ + "static/media/43.70f8d361.jpg";